import "./_posts-list-styles.scss";

import './posts-list';
